// Curated, professional photography (Unsplash) for the DOCM 11.11 landing
// Selected for emotional resonance and diverse human representation — change.org style.

export const IMG = {
  // Hero — diverse hands joining together at golden hour (unity)
  heroPeople:
    "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=1100&q=70",
  // DOCM bridge — diverse crowd cheering under the DECLARATION OF CONSCIOUSNESS banner
  // (self-hosted on backend for resilience). Has the "One Humanity. One Consciousness.
  // One Shared Future." line already embedded in the banner, so no overlay needed.
  bridgeMoment:
    (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "") +
    "/api/uploads/brand/about-banner-v3.jpg",
  // 11.11 cosmic — earth from space at twilight
  cosmicEarth:
    "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1100&q=70",
  // Contribute section
  contributeHands:
    "https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?auto=format&fit=crop&w=1100&q=70",
  // Sign declaration backdrop
  signBackdrop:
    "https://images.unsplash.com/photo-1518607881924-72dd9a1ed81c?auto=format&fit=crop&w=1100&q=70",
};
